import { StateType } from '../../index';
import Immutable from 'immutable';
import moment from 'moment';
import { createSelector } from 'reselect';
import { activeTeamSelector } from '../ActiveTeamReducer/ActiveTeamSelector';

export const dataTeamIsFetchingSelector = (state: StateType) => state.getIn(['team', 'data', 'isFetching']);
export const dataTeamIsFetchedSelector = (state: StateType) => state.getIn(['team', 'data', 'isFetched']) as boolean;
export const dataTeamIsFetchingPatchSelector = (state: StateType) => state.getIn(['team', 'data', 'isFetchingPatch']);
export const dataTeamCountRejectedTeamsSelector = (state: StateType) => state.getIn(['team', 'data', 'rejectedTeams', 'count']);
export const dataTeamCountPendingTeamsSelector = (state: StateType) => state.getIn(['team', 'data', 'pendingTeams', 'count']);

export const teamCompetitionSelector = (state: StateType, competitionId: string) =>
  ((state.getIn(['team', 'data', 'allTeamCompetitions']) as Immutable.List<Immutable.Map<string, any>>) ?? Immutable.List())
    .filter((competition: any) => competition.get('id') === competitionId)
    .first();

export const dataTeamCompetitionTeamBasedNameSelector = (state: StateType) => dataTeamCompetitionTeamSelector(state)?.get('name');
export const dataTeamCompetitionTeamBasedStatusSelector = (state: StateType) => dataTeamCompetitionTeamSelector(state)?.get('status');

export const dataTeamCompetitionTeamSelector = (state: StateType, competitionId?: string) => {
  const competitionList =
    (state.getIn(['team', 'data', 'allTeamCompetitions']) as Immutable.List<Immutable.Map<string, any>>) ?? Immutable.List();
  if (competitionId) {
    return competitionList.filter(competition => competition.get('id') === competitionId).first();
  }

  return competitionList
    .filter(
      competition =>
        competition.get('teamBased') &&
        competition.get('status') === 'ACCEPTED' &&
        moment(competition.get('signUpStartDate') ?? competition.get('startDate')).isBefore(moment()) &&
        moment(competition.get('endDate')).isAfter(moment())
    )
    .first();
};
export const dataTeamCompetitionTeamBasedIdSelector = (state: StateType) => dataTeamCompetitionTeamSelector(state)?.get('id');
export const dataTeamCompetitionTeamBasedStartDateSelector = (state: StateType, competitionId: string) =>
  teamCompetitionSelector(state, competitionId)?.get('startDate');
export const dataTeamCompetitionTeamBasedEndDateSelector = (state: StateType, competitionId: string) =>
  teamCompetitionSelector(state, competitionId)?.get('endDate');
export const dataTeamCompetitionTeamBasedLeaderboardRank = (state: StateType, competitionId: string) =>
  dataTeamCompetitionTeamSelector(state, competitionId)?.getIn(['leaderboard', 'rank']);

export const dataTeamCompetitionTeamBasedLeaderboardScore = (state: StateType, competitionId: string) =>
  dataTeamCompetitionTeamSelector(state, competitionId)?.getIn(['leaderboard', 'score']);

export const dataTeamPendingTeamsSelector = (state: StateType) => state.getIn(['team', 'data', 'pendingTeams']);

export const dataTeamPastTeamsSelector = (state: StateType) => state.getIn(['team', 'data', 'terminatedTeams']);

export const dataTeamCountPastTeams = (state: StateType) => state.getIn(['team', 'data', 'terminatedTeams', 'count']);

export const dataTeamCompetitionsSelector = (state: StateType) =>
  ((state.getIn(['team', 'data', 'allTeamCompetitions']) as Immutable.List<Immutable.Map<string, any>>) ?? Immutable.List()).filter(
    competition => competition.get('teamBased')
  );

export const dataTeamCompetitionsByIdSelector = createSelector(dataTeamCompetitionsSelector, competitions =>
  competitions.reduce((map, competition) => map.set(competition.get('id'), competition), Immutable.Map())
);
export const dataTeamTerminatedTeamsFirstResultSelector = (state: StateType) =>
  state.getIn(['team', 'data', 'terminatedTeams', 'results', 0]);

export const dataTeamIsInAnActiveTeam = createSelector(activeTeamSelector, activeTeam => !!activeTeam);
